import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Observable } from "rxjs";
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
     request = request.clone({
      setHeaders: {
        "Authorization": `IDENTITY ${this.auth.getToken()}`
      },
      body: {...request.body, "_token": this.auth.getToken()}
     });
    return next.handle(request);
  }
}
